<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "kisi"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Yonetim/kisi.vue